<template>
  <div :title="$t('sectionModalArchive.viewAllContactFiles')">
    <button
      type="button"
      class="btn-square btn-secondary btn-rounded"
      @click="AbrirModal()"
    >
      <i class="fa fa-paperclip attachment"></i>
    </button>

    <b-modal
      v-model="abrir"
      :title="$t('sectionModalArchive.contactFiles')"
      hide-footer
    >
      <div v-if="loading" class="loading-container">
        <RotateSquare
          class="loading-position animated fadeIn"
          size="60px"
        ></RotateSquare>
      </div>
      <div v-else>
        <b-table
          :hover="true"
          responsive
          :items="itens"
          :fields="fields"
          striped
          :per-page="itensPorPagina"
          show-empty
          :empty-text="$t('sectionModalArchive.fileNotFound')"
        >
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(data)="data">
            <div class="center">
              <label for>{{ new Date(data.item.data).toLocaleString() }}</label>
            </div>
          </template>
          <template v-slot:cell(tipo)="data">
            <label for="">{{ ObterTipoArquivo(data.item.tipo) }}</label>
          </template>
          <template v-slot:cell(acao)="data">
            <div class="btn-group-sm">
              <a
                class="btn-square-sm btn-secondary btn-rounded"
                :href="$store.getters.baseURL + 'arquivo/obter/' + data.item.id"
                :title="$t('sectionModalArchive.viewFile')"
                target="_blank"
              >
                <i class="fas fa-eye fa-lg text-black"></i>
              </a>
            </div>
          </template>
        </b-table>
        <b-pagination
          v-model="pagina"
          :total-rows="total"
          :per-page="itensPorPagina"
          align="right"
          size="md"
          class="mt-2"
        ></b-pagination>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TipoMensagem from "../../enums/TipoMensagem";
import RotateSquare from "../../components/RotateSquare";
export default {
  name: "ModalArchive",
  components: {
    RotateSquare
  },
  props: {
    contatoId: {
      type: String,
      default: ""
    },
    telefoneId: {
      type: String,
      default: ""
    },
    enumTipoContato:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      abrir: false,
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 0
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "nome",
          label: this.$t("sectionOrcamento.orcamentoNome"),
          sortable: true
        },
        {
          key: "data",
          label: this.$t("sectionEmail.emailData"),
          sortable: true
        },
        {
          key: "tipo",
          label: this.$t("sectionMidia.midiaTipo"),
          sortable: true
        },
        {
          key: "acao",
          label: this.$t("sectionOrcamento.orcamentoAcao"),
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ];
    }
  },
  watch: {
    pagina: function (val) {
      this.ObterGrid(val);
    }
  },
  methods: {
    AbrirModal() {
      this.abrir = true;
      this.ObterGrid(1);
    },
    ObterTipoArquivo(tipo) {
      switch (tipo) {
        case TipoMensagem.Audio:
          return this.$t("sectionParametro.parametroAudio");
        case TipoMensagem.Video:
          return this.$t("sectionParametro.parametroVideo");
        case TipoMensagem.Documento:
          return this.$t("sectionParametro.parametroDocumento");
        case TipoMensagem.Imagem:
          return this.$t("sectionParametro.parametroImagem");
        default:
          return this.$t("textNaoIdentificado");
      }
    },
    ObterGrid(pagina) {
      console.log("é esse", this.enumTipoContato)
      this.loading = true;
      let filtro = {
        Pagina: pagina,
        ContaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        ContatoId: this.contatoId,
        TelefoneId: this.telefoneId,
        ItensPorPagina: 5,
        TipoConversa: this.enumTipoContato
      };
      this.$http({
        url: "/contato/obter-arquivo-grid/",
        data: filtro,
        method: "POST"
      })
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>

<style lang="scss"></style>
